import Vue from 'vue'
import App from './App.vue'
import BaiduMap from 'vue-baidu-map'
import router from './router'
import store from './store'
import Element from 'element-ui'
import './assets/css/style/theme/index.css'
import './assets/css/index.scss'
import 'normalize.css/normalize.css'

Vue.config.productionTip = false
Vue.use(BaiduMap, { ak: 'Wl7B1uLpWMv0XON4XX9O3tANyeEnvZQg' })
Vue.use(Element, { size: 'small', zIndex: 3000 })
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
